const NotFound = ({
  message = "The page you're looking for doesn't exist or the link may have expired.",
}) => {
  return (
    <div className="error-boundary">
      <div className="error-boundary-content">
        <div className="error-brand">Ramp.ai</div>

        <div className="error-divider"></div>

        <h2>Page not found</h2>

        <p className="error-message">{message}</p>

        <div className="error-actions">
          <a href="/" className="error-btn error-btn-primary">
            Go home
          </a>
        </div>

        <p className="error-footer-help">
          Having trouble? <a href="mailto:support@rampwithai.com">Contact support</a>
        </p>
        <p className="error-footer-text">
          &copy; {new Date().getFullYear()} Ramp.ai LLC. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
